import AdminSubCategoryList from './AdminSubCategoryList';
export default AdminSubCategoryList;
